import React, { Fragment, useCallback, useEffect, useState } from "react";

import IdSensorsTable from "components/tables/stations/IdSensorsTable.component";
import { useSelector } from "react-redux";
import SideDialogComponent from "components/dialog/SideDialog.component";
import { useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import Request from "../../../core/requests";
import { openSnackbar } from "store/slices/snackbar";
import { useDispatch } from "react-redux";
import { ValidationSchema } from "../../../conf/sensors";
import SensorDetailForm from "forms/sensors/SensorDetail.form";
import { refreshToken } from "store/user.store";
import { logout } from "store/user.store";
import { useTranslation } from "react-i18next";
const SUPERUSER = "superuser";

const SensorsListContainer = ({
  item,
  setUpdate = () => { },
  handleDeletesensor = () => { },
  openModal,
  handleClose = () => { },
  handleOpen = () => { },
  setIsChageStatusSensor = () => { },
  isChageStatusSensor
}) => {
  const { t } = useTranslation()
  const dispatch = useDispatch();
  const [open, setOpen] = useState(false);
  const {
    user,
    token,
    refresh_token,
    loading: loadingRefresh,
    error: errorRefresh,
  } = useSelector((state) => state.user);
  const [isSuperUser, setIsSuperUser] = useState(false);
  const [isSubmitting, setSubmitting] = useState(false);
  const [isFirstRefresh, setIsFirstRefresh] = useState(true);
  const [dataSubmit, setDataSubmit] = useState(null);

  const { handleSubmit, control, formState, reset } = useForm({
    resolver: yupResolver(ValidationSchema),
    defaultValues: {
      sensor_id: "",
    },
  });

  const handleCloseDialog =() => {
    setIsChageStatusSensor(null)
    setOpen(false);

  };

  const handleClickOpenDialog = useCallback(() => {
    setSubmitting(false);
    reset();
    setOpen(true);
  }, [reset]);

  const onSuccess = useCallback((resp) => {
    setUpdate(resp);
    setIsFirstRefresh(true)
    setSubmitting(true);
    setDataSubmit(true);
    dispatch(
      openSnackbar({
        open: true,
        message: resp.message,
        variant: "alert",
        alert: {
          color: "success",
        },
        close: false,
      })
    );
    // eslint-disable-next-line
  }, []);

  const onFailure = useCallback((error) => {
    setUpdate(error);
    dispatch(
      openSnackbar({
        open: true,
        message: error.response?.data?.message ? error.response.data.message : "Errore",

        variant: "alert",
        alert: {
          color: "error",
        },
        close: false,
      })
    );
    // eslint-disable-next-line
  }, []);

  const onLogout = useCallback((error) => {
    if (error?.response?.status === 403 || error?.response?.status === 401) {
      dispatch(logout());
    }
    // eslint-disable-next-line
  }, []);

  const onError = useCallback(
    (error, data) => {
      setDataSubmit(data);
      if (isFirstRefresh) {
        if (error?.response?.status === 403) {
          dispatch(logout());
        } else {
          if (error?.response?.status !== 401) {
            onFailure(error);
          } else {
            if (isFirstRefresh) {
              dispatch(
                refreshToken({
                  grant_type: "refresh_token",
                  refresh_token: user.refresh_token,
                })
              );
              setIsFirstRefresh(false);
            }
          }
        }
      } else {
        onLogout(error);
      }
    },
    // eslint-disable-next-line
    []
  );

  const onSubmit = useCallback(
    (values) => {
      if (user?.role === SUPERUSER) {
        const data = values;
        if (data?.app_eui) {
          if (data?.sensor_app_keys === undefined) {
            data.sensor_app_keys = {}
          }
          data.sensor_app_keys.app_eui = values?.app_eui;
          delete data.app_eui;
        }
        if (data?.app_key) {
          if (data?.sensor_app_keys === undefined) {
            data.sensor_app_keys = {}
          }
          data.sensor_app_keys.app_key = values?.app_key;
          delete data.app_key;
        }
        if (data?.model) {
          data.model = values?.model?.value;
        }

        Request.stations
          .addSensor({ id: item?.stationId, token: token }, data)
          .then((resp) => onSuccess(resp))
          .catch((error) => onError(error, data));
      }
    },
    // eslint-disable-next-line
    [item, token, refresh_token]
  );

  useEffect(() => {
    if (user?.role === SUPERUSER) setIsSuperUser(true);
  }, [user]);

  useEffect(() => {
    if (dataSubmit && !isFirstRefresh && !errorRefresh && !loadingRefresh) {
      onSubmit(dataSubmit);
    }
    // eslint-disable-next-line
  }, [isFirstRefresh, loadingRefresh, errorRefresh, dataSubmit]);

  return (
    <Fragment>
      <IdSensorsTable
        isSuperUser={isSuperUser}
        stationId={item.stationId}
        rows={item.envSensorsID}
        onClickAdd={handleClickOpenDialog}
        handleDeletesensor={handleDeletesensor}
        openModal={openModal}
        handleOpen={handleOpen}
        handleClose={handleClose}
        setIsChageStatusSensor={setIsChageStatusSensor}
        isChageStatusSensor={isChageStatusSensor}
      />
      <SideDialogComponent open={open} handleCloseDialog={handleCloseDialog}>
        <SensorDetailForm
          errors={formState.errors}
          control={control}
          handleSubmit={handleSubmit(onSubmit)}
          labelButton={t('add')}
          title={t('Add sensor data')}
          isSubmitting={isSubmitting}
          handleCloseDialog={handleCloseDialog}
        />
      </SideDialogComponent>
    </Fragment>
  );
};

export default SensorsListContainer;
